module.exports = __webpack_public_path__ + "static/media/ex13.63410413.jpg";